import React from 'react';
import { Helmet } from "react-helmet";
import '../../styles/brokerage.css'; // Import Brokerage specific CSS
import '../../styles/Fonts.css'; // Import Font specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import bgImage from '../../assets/AboutBG.webp';
import BrokerageServices from './BrokeragetServices';
import BrokerageBenefits from './BrokerageBenefits';
import BrokerageFAQ from './BrokerageFAQ';

const HeroBrokerage = () => {
  return (
    <>
      <Helmet>
        <title>Brokerage Services | RCS Logistics Philippines</title>
        <meta name="description" content="Professional customs brokerage services by RCS Logistics Philippines. Expert documentation handling and compliance solutions for smooth customs clearance." />
        <meta name="keywords" content="brokerage services, customs brokerage, logistics brokerage, customs clearance, RCS Logistics Philippines, professional brokerage, customs documentation, import export brokerage" />
        <meta property="og:url" content="https://rcslogisticsph.com/brokerage" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Brokerage Services | RCS Logistics Philippines" />
        <meta property="og:description" content="Professional customs brokerage services with expert documentation and compliance handling by RCS Logistics Philippines." />
        <meta property="og:image" content="https://rcslogisticsph.com/brokerage-hero-image.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Brokerage Services | RCS Logistics Philippines" />
        <meta property="twitter:description" content="Professional customs brokerage services with expert documentation and compliance handling by RCS Logistics Philippines." />
        <meta property="twitter:image" content="https://rcslogisticsph.com/brokerage-hero-image.png" />
      </Helmet>

      {/* Hero Section */}
      <section 
        className="brokerage-hero-section" 
        style={{ 
          backgroundImage: `url(${bgImage})`
        }}
      >
        <div className="brokerage-hero-overlay"></div>
        <div className="container hero-content">
          <div className="row">
            <div className="col-lg-10 col-xl-9">
              <div className="text-start">
                <button className="hero-badge" disabled>
                  PROFESSIONAL BROKERAGE SERVICES
                </button>
                <h1 className="hero-main-title text-white">
                  Expert Customs Brokerage
                </h1>
                <p className="hero-description text-white">
                  Navigate customs with confidence through our expert brokerage services and comprehensive compliance solutions.
                </p>
                <div className="hero-actions">
                  <a href="/contactUs" className="btn-primary-hero">Get a Quote</a>
                  <a href="#brokerage-services" className="btn-secondary-hero">Our Services</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Include the other sections */}
      <BrokerageServices />
      <BrokerageBenefits />
      <BrokerageFAQ />
    </>
  );
};

export default HeroBrokerage;
